import { render, staticRenderFns } from "./AssessmentTypeData.vue?vue&type=template&id=ac069fc8"
import script from "./AssessmentTypeData.vue?vue&type=script&lang=js"
export * from "./AssessmentTypeData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTypeData.vue?vue&type=style&index=0&id=ac069fc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports